export default ({ theme }) => `
display: flex;
flex-direction: column;
align-items: flex-start;
width: 100%;

.content-container {
  display: flex;
  flex-direction: column;
  width: 100%;

  .promo-and-payment-container{
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    /* align-items: center; */
    width: 100%;

    .promo-code-entry-and-validate-and-activate{
      display: flex;
      flex-direction: row;
      width: 100%;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;

      .promo-code-entry-and-validate{
        display: flex;
        flex-direction: column;
      
        .promo-code-entry{
          display: flex;
        }

        .validation-message{
          color: #ff007d;
          margin: -10px 0 10px 20px;
          height: 15px;
          min-height: 15px;
        }
      }

      .activate-button-container{
        display: flex;
        padding: 12px 10px 0px 10px;

        @media(max-width: 1086px){
          padding: 10px 10px 10px 0px;
        }

      }


    }




    .please-note {
      display: flex;
      justify-content: flex-start;
      font-size: 14px;
      font-style: italic;
      min-height: 20px;

      .note-and-link {
        display: flex;
        flex-direction: row;
        align-items: center;

        .clickable-link {
          cursor: pointer;
          text-decoration: underline;
        }

        .material-icons {
          font-size: 16px;
          padding: 0px 5px;
          cursor: pointer;
          vertical-align: sub;
        }
      }
    }

    .payment-container {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin: 20px;
    }

  }

  .promo-details-container {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
    align-items: flex-start;
    width: 100%;
  }


  p {
    font-size: 20px;
  }

  ul {
    padding-inline-start: 20px;
  }

  @keyframes popIn {
    0% {
      opacity: 0;
      transform: scale(0.95); /* Start closer to normal size */
    }
    40% {
      opacity: 0.5; /* Gradually appear */
      transform: scale(1); /* Reach normal size earlier */
    }
    70% {
      opacity: 1;
      transform: scale(1.02); /* Slight pop */
    }
    100% {
      transform: scale(1); /* Settle at normal size */
    }
  }
  
  .bounce-in {
    animation: popIn 0.5s ease-out 0.3s forwards; /* 0.3s delay */
  }
  



}
`;